import React from "react";
import { string, oneOf, bool } from "prop-types";
import styles from "./Button.module.scss";
import { Arrow } from "./Icons/Arrow";
import { Link } from "react-router-dom";

function getClasses(classes) {
  let classNames = styles.btn;

  switch (classes) {
    case "secondary":
      classNames = `${classNames} ${styles.secondary}`;
      break;
    case "tertiary":
      classNames = `${classNames} ${styles.tertiary}`;
      break;
    case "large":
      classNames = `${classNames} ${styles.large}`;
      break;
    case "largeSecondary":
      classNames = `${classNames} ${styles.largeSecondary}`;
      break;
    case "largeTertiary":
      classNames = `${classNames} ${styles.largeTertiary}`;
      break;
    default:
      classNames = styles.btn;
  }
  return classNames;
}

function createButton(type, classes) {
  if (type === "a") {
    const button = function Button({
      children,
      arrow,
      link,
      disabled,
      extraClasses,
      dark,
      ...props
    }) {
      let classNames = getClasses(classes);

      let leftArrow,
        rightArrow = null;

      if (arrow === "left") {
        leftArrow = <Arrow direction="left" />;
      }

      if (arrow === "right") {
        rightArrow = <Arrow direction="right" />;
      }

      if (arrow !== "none") {
        classNames = `${classNames} ${styles.spaceBetween}`;
      }

      if (extraClasses) {
        classNames = `${classNames} ${extraClasses}`;
      }

      if (dark) {
        classNames = classNames.includes("secondary")
          ? `${classNames} ${styles.darkSecondary}`
          : `${classNames} ${styles.darkBtn}`;
      }

      if (disabled) {
        return (
          <a className={`${classNames} ${styles.disabled}`} {...props}>
            {leftArrow}
            {children}
            {rightArrow}
          </a>
        );
      }

      return (
        <Link className={classNames} to={link} {...props}>
          {leftArrow}
          {children}
          {rightArrow}
        </Link>
      );
    };

    button.propTypes = {
      arrow: oneOf(["left", "right", "none"]),
      text: string,
      link: string,
      extraClasses: string,
      disabled: bool,
      dark: bool,
    };

    button.defaultProps = {
      arrow: "none",
      link: "#",
      extraClasses: null,
      disabled: false,
      dark: false,
    };

    return button;
  } else {
    const button = function Button({
      children,
      arrow,
      extraClasses,
      disabled,
      dark,
      ...props
    }) {
      let classNames = getClasses(classes);

      let leftArrow,
        rightArrow = null;

      if (arrow === "left") {
        leftArrow = <Arrow direction="left" />;
      }

      if (arrow === "right") {
        rightArrow = <Arrow direction="right" />;
      }

      if (arrow !== "none") {
        classNames = `${classNames} ${styles.spaceBetween}`;
      }

      if (extraClasses) {
        classNames = `${classNames} ${extraClasses}`;
      }

      if (dark) {
        classNames = classNames.includes("secondary")
          ? `${classNames} ${styles.darkSecondary}`
          : `${classNames} ${styles.darkBtn}`;
      }

      if (disabled) {
        return (
          <button
            className={`${classNames} ${styles.disabled}`}
            disabled={disabled}
            {...props}
          >
            {leftArrow}
            {children}
            {rightArrow}
          </button>
        );
      }

      return (
        <button className={classNames} {...props}>
          {leftArrow}
          {children}
          {rightArrow}
        </button>
      );
    };

    button.propTypes = {
      arrow: oneOf(["left", "right", "none"]),
      extraClasses: string,
      disabled: bool,
      dark: bool,
    };

    button.defaultProps = {
      arrow: "none",
      extraClasses: null,
      disabled: false,
      dark: false,
    };

    return button;
  }
}

export const Button = createButton("button");
export const ButtonSecondary = createButton("button", "secondary");
export const ButtonTertiary = createButton("button", "tertiary");
export const ButtonLink = createButton("a");
export const ButtonSecondaryLink = createButton("a", "secondary");
export const ButtonTertiaryLink = createButton("a", "tertiary");
export const ButtonLarge = createButton("button", "large");
export const ButtonLargeLink = createButton("a", "large");
export const ButtonLargeSecondary = createButton("button", "largeSecondary");
export const ButtonLargeTertiary = createButton("button", "largeTertiary");
export const ButtonLargeSecondaryLink = createButton("a", "largeSecondary");
export const ButtonLargeTertiaryLink = createButton("a", "largeTertiary");

export default Button;
